import { useEffect, useRef, type RefObject } from 'react';
import { TICKET_ROW_ATTRIBUTE } from './QueueTable';

/**
 * Alla chiusura del dettaglio (pulsante, Esc, backdrop o «Indietro») riporta il focus al link della riga
 * del ticket appena chiuso, dentro il contenitore della tabella. `selectedCode` è il codice aperto
 * (`undefined` a dettaglio chiuso), anche minuscolo come può arrivare dall'URL. La coda lo usa sulla
 * `QueueTable`; una seconda lista con la stessa tabella (l'archivio di #123) lo usa allo stesso modo.
 */
export function useRowFocusReturn(selectedCode: string | undefined): RefObject<HTMLDivElement | null> {
  const tableRef = useRef<HTMLDivElement>(null);
  const previousCode = useRef(selectedCode);
  useEffect(() => {
    const closed = previousCode.current;
    previousCode.current = selectedCode;
    if (!closed || selectedCode) return;
    tableRef.current
      ?.querySelector<HTMLElement>(`[${TICKET_ROW_ATTRIBUTE}="${CSS.escape(closed.toUpperCase())}"] [data-row-link]`)
      ?.focus();
  }, [selectedCode]);
  return tableRef;
}
